import { MouseEvent, ReactNode, useState } from 'react';
import styles from './Menu.module.scss';
import cx from 'classnames';
import { MenuButton, MenuMobile } from 'components/index';
import { useDevice, useOutsideClick } from 'hooks';

type Props = {
  children: ReactNode;
  buttonContainerClassname?: string;
};

export const Menu = ({ children, buttonContainerClassname = '' }: Props) => {
  const [open, setOpen] = useState(false);

  const { isTablet } = useDevice();

  const menuRef = useOutsideClick<HTMLDivElement>(() => setOpen(false));

  const onDesktopMenuClick = (e: MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <div className={cx(styles.menuContainer, buttonContainerClassname)}>
      <MenuButton
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      />
      {open &&
        (isTablet ? (
          <MenuMobile onClose={() => setOpen(false)}>{children}</MenuMobile>
        ) : (
          <div className={styles.menu} ref={menuRef} onClick={onDesktopMenuClick}>
            {children}
          </div>
        ))}
    </div>
  );
};
